import { Badge, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { AlertTriangle, Scale } from 'lucide-react';
import type { AlertInfo, AlertType } from '../models/types';

interface AlertBadgeProps {
  readonly alerts: AlertInfo[];
  readonly size?: 'sm' | 'md';
}

const alertConfig: Record<AlertType, { bg: string; icon: React.ReactNode; label: string }> = {
  price_anomaly: { bg: 'danger', icon: <AlertTriangle size={12} />, label: 'Price Anomaly' },
  size_not_comparable: { bg: 'warning', icon: <Scale size={12} />, label: 'Size Not Comparable' },
};

export function AlertBadge({ alerts, size = 'sm' }: AlertBadgeProps) {
  if (!alerts || alerts.length === 0) {
    return (
      <Badge bg="success" style={{ fontSize: size === 'sm' ? '0.7rem' : '0.8rem' }}>
        OK
      </Badge>
    );
  }

  return (
    <div className="d-flex gap-1 flex-wrap">
      {alerts.map((alert, index) => {
        const config = alertConfig[alert.type];
        return (
          <OverlayTrigger
            key={index}
            placement="top"
            overlay={<Tooltip id={`alert-${index}`}>{alert.details || config.label}</Tooltip>}
          >
            <Badge
              bg={config.bg}
              className="d-flex align-items-center gap-1"
              style={{
                fontSize: size === 'sm' ? '0.7rem' : '0.8rem',
                cursor: 'help',
              }}
            >
              {config.icon}
              {config.label}
            </Badge>
          </OverlayTrigger>
        );
      })}
    </div>
  );
}

